import React from 'react';

import BasicLayout from 'components/BasicLayout';
import RegistrationOnboardingDesktopLayout from 'components/RegistrationOnboardingLayout/RegistrationOnboardingDesktopLayout';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Content, SectionTitle, Subheading } from 'screens/components/CustomerSupport/screens/FaqQuestion/styles';

import {
  Container,
  Header,
  Detail,
  Countries,
  Country,
  CountryName,
  Channel,
  ChannelInfo,
  MailIcon,
  PhoneIcon,
} from './styles';

const GuestNotAuthorized = () => {
  const { t } = useStoreTranslation();

  const isMobile = useIsMobile();

  return !isMobile ? (
    <RegistrationOnboardingDesktopLayout>
      <Container>
        <Header>{t('guestNotAuthorized.title')}</Header>
        <Detail>{t('guestNotAuthorized.subtitle')}</Detail>

        <Countries>
          <Country>
            <CountryName>Brasil</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>ajudaBR@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+55 11 5242 3460 | Whatsapp: +55 11 3181 9723</ChannelInfo>
            </Channel>
          </Country>
          <Country>
            <CountryName>Colombia</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>ayudaCO@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+57 601 3163530 | Whatsapp: +57 15141 131</ChannelInfo>
            </Channel>
          </Country>
          <Country>
            <CountryName>Mexico</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>ayudaMX@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+52 55 8526 2351 | Whatsapp: +57 15141 131</ChannelInfo>
            </Channel>
          </Country>
        </Countries>
      </Container>
    </RegistrationOnboardingDesktopLayout>
  ) : (
    <BasicLayout title={t('customerSupport.title')}>
      <Subheading>{t('guestNotAuthorized.title')}</Subheading>
      <SectionTitle>{t('guestNotAuthorized.subtitle')}</SectionTitle>
      <Content>
        <Countries>
          <Country>
            <CountryName>Brasil</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>&nbsp;ajudaBR@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+55 11 5242 3460 | Whatsapp: +55 11 3181 9723</ChannelInfo>
            </Channel>
          </Country>
          <Country>
            <CountryName>Colombia</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>&nbsp;ayudaCO@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+57 601 3163530 | Whatsapp: +57 15141 131</ChannelInfo>
            </Channel>
          </Country>
          <Country>
            <CountryName>Mexico</CountryName>
            <Channel>
              <MailIcon />
              <ChannelInfo>&nbsp;ayudaMX@rappitravel.com</ChannelInfo>
            </Channel>
            <Channel>
              <PhoneIcon />
              <ChannelInfo>+52 55 8526 2351 | Whatsapp: +57 15141 131</ChannelInfo>
            </Channel>
          </Country>
        </Countries>
      </Content>
    </BasicLayout>
  );
};

export default GuestNotAuthorized;
